import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { StoryStats } from "../components/StoryStats";
import { ProblemSection } from "../components/ProblemSection";
import { HowItWorks } from "../components/HowItWorks";
import { PricingSection } from "../components/PricingSection";
import { CtaBand } from "../components/CtaBand";
import { scrollToSection } from "../components/Navbar";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToSection(location.hash), 300);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <StoryStats />
      <ProblemSection />
      <HowItWorks />
      <PricingSection />
      <CtaBand />
    </main>
  );
}
